import { Body, Box, Input } from '../../../widgets'
import { DataGrid } from './'

export const Table = ({ rows, onRowClick, columns, defaultSortColumn, title, onSearch }) => {
  return (
    <Box column fullWidth gap={8}>
      {title && <Body alt bold>{title}</Body>}
      {onSearch && (
        <Input
          onChange={e => onSearch(e.target.value)}
          leftIcon="Search"
          dark
        />
      )}
      <DataGrid
        columns={columns}
        rows={rows}
        onRowClick={onRowClick}
        defaultSortColumn={defaultSortColumn}
      />
    </Box>
  )
}